/* eslint-disable no-console */
// TODO: Remove all console statements
const BRAZE_CONTENT_CARDS_TIMEOUT_MS = 5000;
const BRAZE_LOG_PREFIX = 'BrazeCount: ';

const waitForBrazeContentCards = async (signal: AbortSignal) => {
  // Braze may not have assigned __brazeContentCards yet, so wait for the event that announces it.
  if (!window.__brazeContentCards) {
    console.log(`${BRAZE_LOG_PREFIX}waiting for event brazeContentCardsSettled`);
    // The signal both drops the listener and unblocks this wait once the caller gives up on it.
    await new Promise<void>((resolve) => {
      window.addEventListener('brazeContentCardsSettled', () => resolve(), { once: true, signal });
      signal.addEventListener('abort', () => resolve(), { once: true });
    });
  }

  // The event is only a signal; the payload always comes from the global promise.
  return (await window.__brazeContentCards) ?? null;
};

export const getBrazeUnViewedContentCardCount = async () => {
  const abortWait = new AbortController();
  let timeoutId: ReturnType<typeof setTimeout> | undefined;
  // Neither the event nor the global promise is guaranteed to arrive, so cap the whole wait.
  const timeout = new Promise<null>((resolve) => {
    timeoutId = setTimeout(() => {
      console.warn(`${BRAZE_LOG_PREFIX}timed out waiting for content cards`);
      abortWait.abort();
      resolve(null);
    }, BRAZE_CONTENT_CARDS_TIMEOUT_MS);
  });

  const settled = await Promise.race([waitForBrazeContentCards(abortWait.signal), timeout]).finally(() =>
    clearTimeout(timeoutId),
  );

  if (settled?.error || !settled?.response?.getUnviewedCardCount) {
    console.warn(`${BRAZE_LOG_PREFIX} empty/error response`, settled);
    return 0;
  }

  console.log(`${BRAZE_LOG_PREFIX} unviewed content card count: ${settled.response.getUnviewedCardCount()}`);
  return settled.response.getUnviewedCardCount();
};
